import BaseApi from './base.api';

export interface VisitType {
  id: number;
  typeCode: string;
  typeName: string;
  description?: string;
  isActive: boolean;
}

const baseAPI = new BaseApi();

export const visitTypeApi = {
  getAllActiveVisitTypes: async (): Promise<VisitType[]> => {
    return await baseAPI.get('/visit-types');
  }
};